<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="12" class="text-center text-sm-center mb-4 mb-sm-0">
        <img src="@/assets/images/logo/logo1.png" style="max-width:100%; max-height: 100px;" />
      </d-col>
    </d-row>

    <!-- Content -->
    <d-row>
      <d-col lg="12" style="text-align:center;">
        <div class="card-signup">
          <h2 class="page-title" style="text-align: center;padding-bottom: 20px;">Entrar</h2>
          <d-form @submit="checkForm">

            <d-form-row>

              <!-- Email -->
              <d-col md="12" class="form-group">
                <label for="feEmail">Email</label>
                <d-form-input type="email" id="feEmail" v-model="feEmail" placeholder="Email" />
              </d-col>

              <!-- Password -->
              <d-col md="12" class="form-group">
                <label for="fePassword">Senha</label>
                <d-form-input type="password" id="fePassword" v-model="fePassword" placeholder="Senha" />
              </d-col>
              <div style="padding-left:5px;">
                <a href="./forget-password">Esqueci minha senha</a>
              </div>

            </d-form-row>
            <div class="message-error" v-if="errorCustom === 1">
              Preencha todos os campos acima!
            </div>
            <div class="message-error" v-if="errorCustom === 2">
              Login ou senha estão errados!
            </div>
            <div style="text-align:right;" v-if="!loading">
              <d-button type="submit" class="btn-accent">Entrar</d-button>
            </div>
            <div style="text-align:right;" v-if="loading">
              <img src="/images/load2.gif" style="height: 20px;" />
            </div>
          </d-form>
        </div>
        <div style="text-align: center;padding-top: 10px;padding-bottom: 20px;">
          <a href="./signup">Ainda não tenho uma conta</a>
        </div>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import config from '../config'
import axios from 'axios'
import {setCookie, getCookie} from '../utils'
export default {
  name: 'login-form',
  data() {
    return {
      errorCustom: 0,
      loading: false,
      feEmail: null,
      fePassword: null,
    };
  },
  methods: {
    checkForm(e) {
      e.preventDefault();
      if (!this.feEmail || !this.fePassword) {
        this.errorCustom = 1;
        return false;
      }
      this.loading = true
      axios.post(config.serverUrl + '/v1/login',
      {
        email: this.feEmail,
        password: this.fePassword
      },
      {})
      .then((res) => {
        this.loading = false
        if (res.data.response) {
          setCookie('token-client', res.data.token, 2);
          setCookie('name-client', res.data.client.name, 2);
          setCookie('email-client', res.data.client.email, 2);
          setCookie('id-client', res.data.client.id, 2);
          document.location.href="./magazine"
        }
      })
      .catch((error) => {
        this.errorCustom = 2
        this.loading = false
        console.log(error)
      })
      return false;
    },
  },
};
</script>

